export default "__VITE_ASSET__BlWuHOSD__"